import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import SvgIcon from "@mui/material/SvgIcon";
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import InfoIcon from '@mui/icons-material/Info';

import {getFeatureGroupName} from "../../../../../misc/helpers";
import BathroomFeatureGroupsIcons from "../../../../common/svgIcons/bathroomFeatureGroupIcons";
import {
  getCategoryOnlyUrl,
  getFeatureUrl, getLookIdUrl, getWizardWithFirstStepCurrentPartId, hideFeatureSection,
} from "../../../lookNavigation/lookFunctions2";
import {
  setLookActiveCategory,
  setLookDemoPointsClicked,
  setLookOpened,
  setLookPageOpened
} from "../../../../../actions/lookFunctions";
//import GroheCategoriesMenuItemWizard from "./groheCategoriesMenuItemWizard";
import {setGroheWizardName} from "../../../../../actions/groheQuotingToolFunctions";
import {setGroheSubCategoryOpened} from "../../../../../actions/groheFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import WithZoomToFeature from "../../../hocs/withZoomToFeature";
import LookCanvasContext from "../../../lookCanvasContext";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {COLORS} from "../../../../../colorThemes";
import {ROUTES} from "../../../../../routes";
import {setWizardActiveItem} from "../../../../../actions/wizardFunctions";


const GroheCategory = (props) => {

  const {intl, fabricatorData, setLookActiveCategory, history, setLookPageOpened, wizardList, setWizardActiveItem,
    isMobile, parentObject, subCategoryOpened, setGroheSubCategoryOpened, lookDemoPointsClicked, shopPageOpened,
    setLookDemoPointsClicked, setLookOpened} = props;

  if (!parentObject) {
    return null
  }

  if (parentObject.partId === "submenu_accessories") {
    return (
      <MenuItem className="look-sidebar__modal-item look-sidebar__modal-item--with-icon"
                onClick={() => setGroheSubCategoryOpened(parentObject.partId)}>
        <ListItemIcon className={"look-icon look-icon--small2" + (subCategoryOpened ? " look-icon--active" : "")}>
          <SvgIcon style={subCategoryOpened ? {fill: COLORS.white} : null}>
            {BathroomFeatureGroupsIcons[parentObject.partId]}
          </SvgIcon>
        </ListItemIcon>
        <FormattedMessage id="grohe.categories.accessories"/>
      </MenuItem>
    )
  }

  const featureGroupClick = (parentObject, zoomToFeatureGroup) => {
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productSidebarCategory + parentObject.partId
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarFeatureGroup + parentObject.partId
    Analytics.sendClickEvent(analyticsLabel);

    if (shopPageOpened) {
      setLookOpened(null);
      setLookPageOpened("");
      history.push(`${ROUTES.shop}/${parentObject.partId}/`);
      return
    }

    const shouldOpenWizardItem = getWizardWithFirstStepCurrentPartId(wizardList, parentObject.partId);
    if (shouldOpenWizardItem) {
      setWizardActiveItem(shouldOpenWizardItem);
      history.push(`${getLookIdUrl(false) + ROUTES.wizard}/${shouldOpenWizardItem.id}`);
      return true
    }

    setLookActiveCategory(IS_PRODUCT_JOURNEY ? isMobile ? "" : parentObject.partId : parentObject.partId);
    setLookPageOpened("");
    const toZoomFeature = parentObject.cartFeature || parentObject.featureGroup.activeNotInVisualizerFeature;
    if (IS_PRODUCT_JOURNEY && parentObject.cartFeature
      && !hideFeatureSection(true, parentObject.partId, toZoomFeature, {visible: false})) {
      history.push(getFeatureUrl(toZoomFeature, !isMobile));
    } else {
      history.push(getCategoryOnlyUrl());
    }
    zoomToFeatureGroup(parentObject.partId, toZoomFeature, null, false, IS_PRODUCT_JOURNEY);
    if (!lookDemoPointsClicked) {
      setLookDemoPointsClicked(true);
    }
  }

  const featureGroupName = getFeatureGroupName(parentObject.featureGroup, intl, fabricatorData);

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => (
            <MenuItem className="look-sidebar__modal-item"
                      onClick={() => featureGroupClick(parentObject, zoomToFeatureGroup)}>
              <ListItemIcon>
                {BathroomFeatureGroupsIcons[parentObject.partId] ? <SvgIcon>{BathroomFeatureGroupsIcons[parentObject.partId]}</SvgIcon> : <InfoIcon/>}
              </ListItemIcon>
              {featureGroupName}
            </MenuItem>
          )}
        </WithZoomToFeature>
      )}
    </LookCanvasContext.Consumer>
  )
};

GroheCategory.propTypes = {
  parentObject: PropTypes.object.isRequired,
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {subCategoryOpened} = store.groheState;
  const {lookDemoPointsClicked} = store.lookState;
  const {shopPageOpened} = store.shopState;
  const {wizardList} = store.wizardState;

  return {
    fabricatorData: store.fabricatorState,
    isMobile,
    subCategoryOpened,
    lookDemoPointsClicked,
    shopPageOpened,
    wizardList,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookPageOpened,
  setGroheWizardName,
  setGroheSubCategoryOpened,
  setLookDemoPointsClicked,
  setLookOpened,
  setWizardActiveItem,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheCategory)
  )
)
